<div
  style="
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin: 0px 0px -10px 0;
  "
>
  <h3 *ngIf="data.action == 'add'" mat-dialog-title>
    <strong> Agregar Encargado</strong>
  </h3>
  <div
    style="
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    "
    class="mat-elevation-z3"
    (click)="dialogRef.close()"
  >
    <i class="fa fa-times"></i>
  </div>
</div>

<div
  *ngIf="data.responsible == 'tercero'"
  style="
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: auto;
  "
>
  <ng-template class="font" matStepLabel>Selecion de tercero</ng-template>
  <div style="width: 100%; margin-top: 30px">
    <data-table
      [title]="titleTerceros"
      [columns]="columnasTerceros"
      [configuration]="configurationTerceros"
      [reloadTable]="recargarTablaTerceros"
      (clickRow)="clickFilaTerceros($event)"
      [params]="paramsProviders"
      [url]="urlGetTablaTerceros"
    ></data-table>
  </div>

  <div style="margin: 10px 10px 0 0">
    <mat-chip-list #chipList aria-label="Fruit selection">
      <mat-chip
        *ngFor="let data of chipResponsable"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(data)"
      >
        {{ data.nombre }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>

  <button
    style="width: 70%; margin-top: 15px"
    color="primary"
    class="button-save mat-elevation-z5"
    (click)="finalizar()"
    mat-raised-button
  >
    Aceptar
  </button>
</div>

<div
  *ngIf="data.responsible == 'usuario'"
  style="
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: auto;
  "
>
  <ng-template matStepLabel>Selecion de usuarios</ng-template>
  <div style="width: 100%; margin-top: 30px">
    <data-table
      [title]="titleUsuarios"
      [columns]="columnasUsuarios"
      [configuration]="configurationUsuarios"
      [reloadTable]="recargarTablaUsuarios"
      (clickRow)="clickFilaUsuarios($event)"
      [params]="[{ id: 'state', value: 1 }]"
      [url]="urlGetTablaUsuarios"
    ></data-table>
  </div>

  <div style="margin: 10px 10px 0 0">
    <mat-chip-list #chipList aria-label="Fruit selection">
      <mat-chip
        *ngFor="let data of chipResponsable"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(data)"
      >
        {{ data.nombre }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>

  <button
    style="width: 70%; margin-top: 15px"
    color="primary"
    class="button-save mat-elevation-z5"
    (click)="finalizar()"
    mat-raised-button
  >
    Aceptar
  </button>
</div>
